module.exports = __webpack_public_path__ + "static/img/a-12-512.3889fcc2.png";